/**
 * RelatedCategories Functional Component
 * @Package - seo
 * @Author - Cybage@UPWA-Team
 * @description: Common SEO RelatedCategories
 */
/**
 *   SEO's RelatedCategories Component
 */
import React, { useContext, useMemo } from 'react'
import { Box, useResponsiveWrapperContext } from '@usap/uicomponents'
import { Title, ImageWithText } from '@usap/widgets'
import { LocalContext } from '../../helpers/useLocalContext'
import seoIds from '../../../config/seoIds'

export default function SeoRelatedCategories({ id, data }) {
  const { isDesktop } = useResponsiveWrapperContext()
  const { localContext } = useContext(LocalContext)
  const { Link, isBot } = localContext

  const colWidth = isDesktop ? '16.66' : '33.33%'
  const styleMemo = useMemo(
    () => ({
      box1Marg: { horizontal: 'auto', vertical: '0px' },
      box1Pad: { horizontal: 'small', top: 'medium', bottom: 'large' },
      box2Marg: { horizontal: 'small', bottom: 'medium' },
      titleSize: isDesktop ? 'medium' : 'small',
    }),
    [isDesktop]
  )
  return (
    <Box background="light-1">
      <Box
        id={id}
        width="1248px"
        margin={styleMemo.box1Marg}
        pad={styleMemo.box1Pad}
      >
        <Box id="RelatedCategoriesHeading" margin={styleMemo.box2Marg}>
          {/* Title for the RelatedCategories Component */}
          <Title
            type="h3"
            size={styleMemo.titleSize}
            label="Related Categories"
          />
        </Box>

        <Box id="RelatedCategoriesSection" direction="row" wrap>
          {data.map(({ image, text, link }, index) => (
            <ImageWithText
              key={text}
              id={seoIds.relatedCategories.replace('{{key}}', index)}
              isDesktop={isDesktop}
              isBot={isBot}
              imageSrc={image}
              imageHeight={isDesktop ? '175px' : '90px'}
              imageText={text}
              Link={Link}
              to={link}
              boxWidth={colWidth}
              cloudinaryParams="h_144"
            />
          ))}
        </Box>
      </Box>
    </Box>
  )
}
